import { UserAnalyticsDetailsResponse } from './types';

/**
 * Select function to map the user analytics details response data to the data needed for the usage details table.
 * @param data - The user analytics details response data.
 * @returns The mapped user analytics details data.
 */
export function mapUserAnalyticsRow(data: UserAnalyticsDetailsResponse) {
  return {
    hasNextPage: data.hasNextPage,
    rows: data.data,
    totalCount: data.totalCount,
  };
}
